import commonGetters from '@/store/data/common/getters'

const getters = {
    ...commonGetters,
    tree(state) {
        return state.tree
    }
}

export default getters
